import { render, staticRenderFns } from "./TabRisquesConfig.vue?vue&type=template&id=072e8350&"
import script from "./TabRisquesConfig.vue?vue&type=script&lang=js&"
export * from "./TabRisquesConfig.vue?vue&type=script&lang=js&"
import style0 from "./TabRisquesConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports